import React, { useEffect, useState } from 'react';
import { cellRendererCheck, currencyFormat, dateFormate } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';



const columns = [
    {
        dataField: 'options',
        text: 'Options',
        sort: false,
        width: 80,
        show: true,
        hidecolFilter: true,
        action: true
    },
    {
        dataField: 'adjustmentDate',
        text: 'Adjustment Date',
        sort: true,
        width: 130,
        show: true,
        inputType: 'date',
        hideColFilter: false,
        cellRenderer: (rowData) => dateFormate(rowData.adjustmentDate),
    },
    {
        dataField: 'adjustedQuantity',
        text: 'Packages',
        sort: true,
        width: 100,
        show: true,
        inputType: 'number',
        hideColFilter: false,
        cellRenderer: (rowData) => cellRendererCheck(rowData.adjustedQuantity),
    },
    {
        dataField: 'comments',
        text: 'Reason/Note',
        sort: true,
        width: 100,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData) => cellRendererCheck(rowData.comments),
    }, 
    {
        dataField: 'createdByID',
        text: 'Created By',
        sort: false,
        width: 100,
        show: true,
        inputType: 'text',
        hideColFilter: false,
        cellRenderer: (rowData) => cellRendererCheck(rowData.createdByID),
    },
    {
        dataField: 'createdDate',
        text: 'Created Date',
        sort: true,
        width: 100,
        show: true,
        inputType: 'date',
        hideColFilter: false,
        cellRenderer: (rowData) => dateFormate(rowData.createdDate),
    },
];


const AdjustmentTable = (props) => {
 
    const {  tenantID,
        data,
        loading,
        onExport,
        filters,
        totalSize,
        onPageChange,
        refetch,
        setLoading,
        onSearchColumnFilters,
        reset,
        manvalPharmacy } = props;

    const [state, updateState] = useState({
        tableData: [],
        backUpData: [],
        filters: filters,
    });
    useEffect(() => {
        setState({ tableData: data, backUpData: data });
    }, [data]);
    const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));

    useEffect(() => {
        setState({ filters: filters });
    }, [filters]);

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        setState({
            filters: filter,
        });
        onPageChange(filter);
    };

    const handleFilterCancel = () => {
        refetch(true);
    };

    const handleSearchColumnFilters = (colFilter) => {
        if (onSearchColumnFilters) {
            const filter = { ...state.filters, filters: colFilter, currentPage: 1 };
            onSearchColumnFilters(filter);
            setState({
                filters: filter,
            });
        }
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            onPageChange(colFilterOn, true);
        } else {
            setState({
                filters: filter,
            });
            onPageChange(filter);
        }
    };

    const handleSort = (filter, hasColFilter) => {
        setState({
            filters: filter,
        });
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
        }
    };

    const handelAdd = async () => {
        await manvalPharmacy();

   }

    const { filters: colFilter, backUpData } = state;
   
debugger;
    return <div className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={data?.length > 0 ? 'fixed-height' : 'default'}>
        <ReactStrapTable
            id='configuration-table1'
            fixedColumn
            data={backUpData}
            loading={loading}
            columns={columns}
            add={"Add"}
            addbutton={true}
            addAccmulations={true}
            hasPagination = {backUpData?.length>0 ?true : false}
            buttononclick={handelAdd}
            onPageSizeChange={onPageSizeChange}
            pageSize={colFilter.pageSize}
           // onExport={onExport}
            onPageChange={onHandlePageChange}
            currentPage={colFilter.currentPage}
            totalRecords={totalSize}
            handleSort={handleSort}
            onFilterCancel={handleFilterCancel}
            filters={colFilter}
            onSearchColumnFilters={handleSearchColumnFilters}
        />
    </div>;
};

export default AdjustmentTable;
